import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'localizeDate',
  pure: false
})
export class LocalizeDatePipe implements PipeTransform {

  private preValue = "";
  private returnValue = "";
  constructor() {

  }

  transform(value: any, pattern: string = 'mediumDate'): any {

    if (this.preValue !== value) {
      this.preValue = value;
      const dater = new DatePipe('en');
      if (typeof value === 'string')
        this.returnValue = dater.transform(value.split('T')[0], pattern);
      else
        this.returnValue = dater.transform(value, pattern);
    }
    return this.returnValue;
  }

}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/shared/date-localization/localize-date.pipe.ts